<template>
    <v-btn-toggle v-model="activeFilter" mandatory>
        <v-btn size="small" :value="false">
            {{ $t('inactive') }}
        </v-btn>
        <v-btn size="small" :value="true" :color="activeFilter ? 'primary' : null">
            {{ $t('active') }}
        </v-btn>
    </v-btn-toggle>
</template>

<script setup lang="ts">
    const activeFilter = defineModel<boolean>()
</script>
